
import {
  isEmpty, find, remove, clone, uniqBy,
} from 'lodash';
import Driver from 'driver.js';
import { dom } from 'quasar';
import { mapActions, mapGetters, mapMutations } from 'vuex';
// import EventBus from '../events';
import ActivitiesComponent from './ActivitiesComponent.vue';
import ActivitiesList from '../views/budgets/ActivitiesList.vue';
import ChecklistComponent from './ChecklistComponent.vue';
import PaymentOrder from '../views/payments/PaymentOrder.vue';
import AdsApi from '../libs/ads-request/ads-api';
import { addActivity } from '../libs/helpers';
import ERROR_MESSAGES from '../libs/errorMessages';
import getAdditionalQuotationAmounts from '../modules/quotation/application/getAdditionalQuotationAmounts';
import vwgif from '../assets/vw-toggle.gif';
import audigif from '../assets/audi-toggle.gif';
import seatgif from '../assets/seat-toggle.gif';

const BUDGET_STATUS = [103, 104, 105, 107];
export default {
  name: 'DetailsCarComponent',
  components: {
    ActivitiesComponent,
    ActivitiesList,
    ChecklistComponent,
    PaymentOrder,
  },
  inheritAttrs: false,
  props: {
    activitiesEnable: Boolean,
    contracted: Boolean,
    showTooltip: Boolean,
    isInvoiceEnabled: Boolean,
    reset: Boolean,
    checklistEnable: Boolean,
  },
  data() {
    return {
      responseComplete: [],
      redList: [],
      yellowList: [],
      greenList: [],
      unbudgedList: [],
      activitySelected: null,
      effectiveDate: null,
      effectiveDateEnd: null,
      showView: false,
      loaderError: false,
      actionError: '',
      addOtherCharges: false,
      showTotals: true,
      expand: true,
      expand2: false,
      expandTotals: false,
      splitterModel: 20,
      additionalTotal: 0,
      taxesAmount: 0,
      taxesAmountPreinvoice: 0,
      preInvoiceTotal: 0,
      preInvoiceSubtotal: 0,
      preInvoiceTotalAltern: 0,
      total: 0,
      authorizedTotal: 0,
      otherCharges: 0,
      recordsWithBudget: 0,
      heightImage: 0,
      titleAdditionals: '¡Revisa tu reporte de reparaciones adicionales!',
      subAdditionals: 'Aquí podrás ver las reparaciones adicionales que necesita tu vehículo',
      titleInventary: '¡Revisa tu reporte de inventario!',
      subInventary: 'Aquí podrás ver los puntos estables que no requieren correción.',
      loaderMessage: 'Cargando presupuestos adicionales ...',
      tab: 'inventario',
      innerTab: 'innerMails',
      showButtonCloseTutorial: false,
      tutorialActive: false,
      driver: null,
      showTutorialMobile: false,
      stepTutorialMobile: 0,
      isFinishTutorial: false,
      isAdditionalBudgets: false,
      shadow: false,
    };
  },
  computed: {
    ...mapGetters('Tutorial', {
      activateTutorial: 'getActivateTutorial',
    }),
    ...mapGetters('Activity', {
      parentSuperorderGreenChecklistActivities: 'parentSuperorderGreenChecklistActivities',
    }),

    mobile() {
      return this.$q.screen.lt.md;
    },
    desktop() {
      return this.$q.screen.gt.md;
    },
    tablet() {
      return this.$q.screen.lt.lg && this.$q.screen.gt.sm;
    },

    greenActivities() {
      return [...this.greenList, ...this.parentSuperorderGreenChecklistActivities];
    },
  },
  watch: {
    reset() {
      this.activitySelected = null;
    },
    activateTutorial() {
      if (this.activateTutorial) {
        this.showTooltip = false;
        if (!this.mobile) this.initTour();
        else this.initTutorialMobile();
      } else {
        this.showTooltip = true;
        this.tutorialActive = false;
        this.showButtonCloseTutorial = false;
      }
    },
  },
  mounted() {
    this.isAdditionalBudgets = this.$session.get('showAdditionalBudgets');
    this.initialCharge();
  },
  methods: {
    ...mapActions('Quotation', ['getFrozenQuotation']),
    ...mapMutations('Tutorial', ['SET_ACTIVATE_TUTORIAL']),
    ...mapMutations('Activity', ['SET_ADDITIONAL_ORDERS_ACTIVITIES']),
    isEmpty,
    afterCharge() {
      if (!this.mobile) {
        const { height } = dom;
        this.heightImage = height(document.getElementById('container-image'));
      }

      if ((this.$session.get('showTutorial') === 0 || this.$session.get('showTutorial') === null) && (this.redList.length > 0 || this.yellowList.length > 0)
          && (this.redList[0].show === true || this.yellowList[0].show === true)) {
        setTimeout(() => {
          if (!this.mobile) {
            this.initTour();
          } else {
            this.initTutorialMobile();
          }
        }, 500);
      }
    },
    authorizeOrder() {
      this.loaderShow('Autorizando orden');

      let authorizedActivities = [];
      const packages = [];

      authorizedActivities = authorizedActivities.concat(this.joinList(clone(this.redList), 'accept'));

      authorizedActivities = authorizedActivities.concat(this.joinList(clone(this.yellowList), 'accept'));

      authorizedActivities.forEach((activity) => {
        this.autorizedActivitiesRemap(activity, packages);
      });

      AdsApi.acceptQuotation(packages)
        .then(async (res) => {
          const response = res.data;
          if (!response.success) throw new Error(`[${response.errorCode}] ${response.errorDescription}`);
          this.sendPushAdviser();
          this.$session.remove('activities');
          this.disabled = true;
          this.isAuthorized = true;
          this.isAuthGeneralBudget = false;
          this.redList = [];
          this.yellowList = [];
          this.greenList = [];
          if (this.isAuthorized) {
            this.isFinishTutorial = true;
            this.showTooltip = false;
          }
          await this.getPreinvoice();
          await this.getAdditionalActivities();
          await this.getUnbudgetedActivities();
          this.$nextTick(() => {
            this.isAcceptBudget = true;
            setTimeout(() => {
              this.isAcceptBudget = false;
            }, 3000);
          });
        })
        .catch(() => {
          this.actionError = ERROR_MESSAGES.ACTION;
        })
        .finally(this.loaderHide);
    },
    autorizedActivitiesRemap(activity, packages) {
      let acceptedResult = null;
      const activities = remove(
        this.responseComplete,
        (a) => a.order_activity_id === activity.order_activity_id,
      );
      const packageIds = uniqBy(
        activities.filter((activityItem) => activityItem.pack_category !== 'CP'),
        'pack_id',
      ).map((activityItem) => activityItem.pack_id);

      const partsIds = activities
        .filter((activityItem) => activityItem.pack_category === 'CP' && activityItem.part_brand == null)
        .map((activityItem) => activityItem.part_id);

      const labourIds = activities
        .filter((activityItem) => activityItem.pack_category === 'CP' && activityItem.part_brand?.toLowerCase() === 'manodeobra')
        .map((activityItem) => activityItem.part_id);

      if (activity.accepted) {
        acceptedResult = 1;
      } else if (!activity.accepted) {
        acceptedResult = 0;
      }

      packageIds.forEach((p) => {
        packages.push({
          packageId: p,
          quotationId: activity.quotation_id,
          status: acceptedResult,
        });
      });
      partsIds.forEach((p) => {
        packages.push({
          partId: p,
          quotationId: activity.quotation_id,
          status: acceptedResult,
        });
      });
      labourIds.forEach((p) => {
        packages.push({
          labourId: p,
          quotationId: activity.quotation_id,
          status: acceptedResult,
        });
      });
    },
    async changeItem(item) {
      const clonedItem = item;
      if (this.authorizedDisable) this.authorizedDisable = false;
      clonedItem.accepted = !clonedItem.accepted;

      this.listActivitiesRemap(clonedItem);

      this.checkListActivities();

      try {
        this.updateAdditionalQuotationAmounts();
        if (this.addOtherCharges) {
          this.total = this.Decimal(this.additionalTotal)
            .add(this.Decimal(this.taxesAmount))
            .add(this.Decimal(this.preInvoiceTotal))
            .add(this.Decimal(this.otherCharges))
            .toFixed(2)
            .toString();
        } else {
          this.total = this.Decimal(this.additionalTotal)
            .add(this.Decimal(this.taxesAmount))
            .add(this.Decimal(this.preInvoiceTotal))
            .toFixed(2)
            .toString();
        }
      } catch (error) {
        this.actionError = ERROR_MESSAGES.ACTION;
      }
      this.setActivitiesInSession();
    },
    listActivitiesRemap(item) {
      this.redList.forEach((activity) => {
        const clonedActivity = activity;
        if (clonedActivity.pack_price) {
          if ((item.pack_category !== 'CP' && clonedActivity.pack_id === item.pack_id) || (clonedActivity.part_id === item.part_id)) clonedActivity.accepted = item.accepted;
        } else {
          clonedActivity.accepted = false;
        }
      });

      this.yellowList.forEach((activityYellow) => {
        const clonedActivity = activityYellow;
        if (clonedActivity.pack_price) {
          if ((item.pack_category !== 'CP' && clonedActivity.pack_id === item.pack_id) || (clonedActivity.part_id === item.part_id)) clonedActivity.accepted = item.accepted;
        } else {
          clonedActivity.accepted = false;
        }
      });
    },
    disabledActivity() {
      const activitiesInPack = [];

      const dataRed = this.checkActivityDisabled(this.redList, activitiesInPack);
      this.redList = dataRed.list;

      const dataYellow = this.checkActivityDisabled(this.yellowList, dataRed.activitiesInPack);
      this.yellowList = dataYellow.list;
    },
    checkActivityDisabled(list, activitiesInPack) {
      list.forEach((activity) => {
        const clonedActivity = activity;
        if (!this.isAuthorized) {
          if (clonedActivity.pack_category !== 'CP') {
            const object = find(activitiesInPack, (a) => a.pack_id === clonedActivity.pack_id);
            if (object == null) activitiesInPack.push(clonedActivity);
            clonedActivity.disabled = this.checkDisableElement(activitiesInPack, clonedActivity);
          } else {
            clonedActivity.disabled = false;
          }
        } else {
          clonedActivity.disabled = true;
        }
      });

      return {
        list,
        activitiesInPack,
      };
    },
    checkDisableElement(activitiesInPack, clonedActivity) {
      let disabled = false;
      if (activitiesInPack.length > 0) {
        activitiesInPack.forEach((activityInPack, index) => {
          const copyActivitiesInPack = activitiesInPack[index];
          if (copyActivitiesInPack.order_activity_id !== clonedActivity.order_activity_id
                  && copyActivitiesInPack.pack_id === clonedActivity.pack_id) {
            disabled = true;
          }
        });
      }
      return disabled;
    },
    getAdditionalActivities() {
      if (this.activitiesEnable) {
        return this.getActivities();
      }

      if (this.checklistEnable) {
        return this.getChecklistActivities();
      }

      return Promise.resolve();
    },
    activitiesRemapMethod(data) {
      let authorized = true;
      let activitiesAcepted = 0;
      const packIds = [];
      data.forEach((activity) => {
        const clonedActivity = activity;
        let acceptedActivity = null;

        if (!BUDGET_STATUS.includes(+clonedActivity.view_status)
              && authorized === true) authorized = false;

        if (+clonedActivity.view_status === 107) activitiesAcepted += 1;

        clonedActivity.show = true;

        if (clonedActivity.accepted === 0) {
          acceptedActivity = false;
        } else if (clonedActivity.accepted === 1) {
          acceptedActivity = true;
        }

        const accepted = acceptedActivity;

        clonedActivity.accepted = accepted;

        if (clonedActivity.activity_status_id === 3) {
          this.yellowList = addActivity(clonedActivity, this.yellowList, packIds);
        }
        if (clonedActivity.activity_status_id === 4) {
          this.redList = addActivity(clonedActivity, this.redList, packIds);
        }
        if (+clonedActivity.otherChargesAmount > 0) {
          this.otherCharges = clonedActivity.otherChargesAmount;
        }
      });

      this.isAuthorized = authorized;

      this.showTotals = !(activitiesAcepted === data.length);

      this.recordsWithBudget = this.redList.length + this.yellowList.length;
    },
    getUnbudgetedActivities() {
      return AdsApi.getUnbudgetedActivities()
        .then((orders) => {
          this.SET_ADDITIONAL_ORDERS_ACTIVITIES(orders);
          const ordersArray = orders[0].activityClient;
          this.unbudgedList = uniqBy(ordersArray, 'order_activity_id');
          orders.forEach((order) => {
            this.orderRemap(order);
          });
          this.redList = this.sortList(this.redList);
          this.yellowList = this.sortList(this.yellowList);
        })
        .catch((error) => {
          throw error;
        });
    },
    orderRemap(order) {
      order.activityClient.forEach((activity) => {
        const principalActivityCloned = activity;
        principalActivityCloned.show = false;

        if (
          principalActivityCloned.activity_status_id === 2
          && principalActivityCloned.inventario === 1
        ) {
          const object = find(
            this.greenList,
            (a) => a.order_activity_id === principalActivityCloned.order_activity_id,
          );
          if (object == null) this.greenList.push(principalActivityCloned);
        }

        if (principalActivityCloned.activity_status_id === 3
                && principalActivityCloned.pack_id_dms != null) {
          const object = find(
            this.yellowList,
            (a) => a.order_activity_id === principalActivityCloned.order_activity_id,
          );
          if (object == null) this.yellowList.push(principalActivityCloned);
        }

        if (principalActivityCloned.activity_status_id === 4
                && principalActivityCloned.pack_id_dms != null) {
          const object = find(
            this.redList,
            (a) => a.order_activity_id === principalActivityCloned.order_activity_id,
          );
          if (object == null) this.redList.push(principalActivityCloned);
        }
      });
    },
    getPreinvoice() {
      return AdsApi.getPreinvoice()
        .then((data) => {
          this.preInvoiceTotal = data.total;
          this.preInvoiceSubtotal = data.subtotal;
          this.taxesAmountPreinvoice = data.taxesAmount;
          this.preInvoiceTotalAltern = data.total;
        })
        .catch((error) => {
          throw error;
        });
    },
    joinList(list, type) {
      let resultArray = [];
      if (list.length > 0) {
        if (type === 'accept') {
          resultArray = remove(list, (l) => !BUDGET_STATUS.includes(+l.view_status));
        }

        if (type === 'validate') {
          resultArray = remove(list, (l) => l.accepted === false || l.accepted === null);
        }
      }
      return resultArray;
    },
    redirectToReport(activity) {
      this.activitySelected = activity.order_activity_id;

      if (!this.mobile) {
        this.$emit('showDetail', {
          activity,
          heightImage: this.heightImage,
        });
      } else {
        this.$router.push({
          name: 'report',
          params: {
            id: activity.order_activity_id,
            activity,
          },
        });
      }
    },
    scrollHandler() {
      const { activitiesContainer } = this.$refs;
      const activitiesContainerOffset = activitiesContainer.$el.offsetTop + 500;
      const { activityTotal } = this.$refs;
      const offset = this.$q.screen.height + window.pageYOffset;

      if (!this.tutorialActive) {
        if (offset > activitiesContainerOffset) {
          activityTotal.$el.classList.add('sticky');
        } else {
          activityTotal.$el.classList.remove('sticky');
        }
      }
    },
    sendPushAdviser() {
      AdsApi.sendPushAdviser()
        .then((res) => {
          const response = res.data;

          if (!response.success) throw new Error(`[${response.errorCode}] ${response.errorDescription}`);
        });
    },
    showPopover() {
      setTimeout(() => {
        const popover = document.getElementsByClassName('tutorial-detail').item(0);
        const top = parseInt(popover.style.top, 10);
        const left = parseInt(popover.style.left, 10);
        popover.style.top = `${top - 15}px`;
        popover.style.left = `${left + 15}px`;
      }, 300);
    },
    initTour() {
      this.$nextTick(() => {
        this.driver = null;
        const tutorialElementClass = 'tutorial-authorization';
        const tutotialTopPosition = 'top-center';
        let image = null;

        switch (this.$session.get('brand')) {
          case 'volkswagen':
            image = vwgif;
            break;
          case 'audi':
            image = audigif;
            break;
          case 'seat':
            // eslint-disable-next-line no-unused-vars
            image = seatgif;
            break;
          default:
            break;
        }
        this.driver = new Driver({
          className: 'tutorial',
          padding: 1,
          doneBtnText: 'Siguiente >',
          closeBtnText: 'Cerrar',
          nextBtnText: 'Siguiente >',
          prevBtnText: '< Anterior',
          opacity: 0.2,
          allowClose: false,
          onDeselected: () => {
            this.showButtonCloseTutorial = false;
          },
          onHighlighted: (element) => {
            this.showButtonCloseTutorial = true;
            this.tutorialActive = true;

            if (element.getNode().id === 'activity-detail') {
              window.scrollTo(0, 600);
              this.showPopover();
            }
            if (element.getNode().id === 'activity-authorization') {
              this.showPopover();
            }

            if (element.getNode().id === 'activity-restrictions') {
              setTimeout(() => {
                const popover = document.getElementsByClassName('tutorial-restriccions').item(0);
                const top = parseInt(popover.style.top, 10);
                const left = parseInt(popover.style.left, 10);
                popover.style.top = `${top - 15}px`;
                popover.style.left = `${left + 15}px`;
              }, 300);
            }
          },
        });

        let position = tutotialTopPosition;

        if (this.tablet || this.mobile) {
          position = 'top-right';
        }
        const steps = [
          {
            element: '#activities-container',
            popover: {
              title: this.titleInventary,
              description: this.subInventary,
              position,
              className: 'activities-container',
            },
          },
          /* {
            element: '#activities-container',
            popover: {
              title: this.titleAdditionals,
              description: this.subAdditionals,
              position: tutotialTopPosition,
              className: 'activities-container',
            },
          },
          {
            element: '#activity-detail',
            popover: {
              title: 'Checa los detalles de cada avería',
              description: 'Da clic en el ícono y revisa los detalles',
              position,
              className: 'tutorial-detail',
            },
          },
          {
            element: '#activity-authorization',
            popover: {
              title: '¡Repara los detalles!',
              description: `<div>Aquí podrás autorizar o rechazar las averías</div>
              <div style='height: 57px; width: 340px;'><img src='${image}' alt='toggle' /></div>`,
              position,
              className: tutorialElementClass,
            },
          }, */
        ];

        if (this.checkRestriccions()) {
          steps.push({
            element: '#activity-restrictions',
            popover: {
              title: 'Checa las restricciones del paquete',
              description: 'Da clic en la etiqueta.',
              position: tutotialTopPosition,
              className: 'tutorial-restriccions',
            },
          });
        }
        steps.push({
          element: '#activity-total',
          popover: {
            title: '¡Autoriza tu presupuesto aquí!',
            description:
              'Autoriza tus reparaciones y enseguida comenzaremos a trabajar, si tienes dudas, podrás contactar a tu asesor de servicio para aclararlas',
            position: 'top-right',
            className: tutorialElementClass,
          },
          onNext: () => {
            this.isFinishTutorial = true;
            this.SET_ACTIVATE_TUTORIAL(false);
          },
        });

        this.driver.defineSteps(steps);

        this.driver.start();
      });
    },
    getChecklistActivities() {
      return AdsApi.getFrozenQuotation()
        .then(async (data) => {
          this.responseComplete = data;

          this.activitiesRemapMethod(data);

          this.disabledActivity();
          this.setActivitiesInSession();

          const hasAnyPersistedAcceptedValue = this.redList.some(
            (activity) => activity.accepted !== null,
          ) || this.yellowList.some(
            (activity) => activity.accepted !== null,
          );

          if (!hasAnyPersistedAcceptedValue) this.authorizedDisable = true;
        })
        .catch((error) => {
          throw error;
        });
    },
    getActivities() {
      return AdsApi.getAdditionalActivities(this.$session.get('orderId'))
        .then(async (data) => {
          let authorized = true;
          const packIds = [];

          this.responseComplete = data;

          data.forEach((activity) => {
            const cloneActivity = activity;

            if (!BUDGET_STATUS.includes(+cloneActivity.view_status)
              && authorized === true) authorized = false;

            cloneActivity.show = true;

            let accepted = null;
            if (activity.accepted === 0) accepted = false;
            else if (activity.accepted === 1) accepted = true;

            cloneActivity.accepted = accepted;

            if (activity.activity_status_id === 3) {
              this.yellowList = addActivity(activity, this.yellowList, packIds);
            }
            if (activity.activity_status_id === 4) {
              this.redList = addActivity(activity, this.redList, packIds);
            }
            cloneActivity.disabled = true;
          });
        })
        .catch((error) => {
          throw error;
        });
    },
    orderRempa(order) {
      order.activityClient.forEach((activity) => {
        const clonedActivity = activity;
        clonedActivity.show = false;

        if (clonedActivity.activity_status_id === 2) {
          const object = find(
            this.greenList,
            (a) => a.order_activity_id === activity.order_activity_id,
          );
          if (object == null) this.greenList.push(activity);
        }

        if (clonedActivity.activity_status_id === 3) {
          const object = find(
            this.yellowList,
            (a) => a.order_activity_id === activity.order_activity_id,
          );
          if (object == null) this.yellowList.push(activity);
        }

        if (clonedActivity.activity_status_id === 4) {
          const object = find(
            this.redList,
            (a) => a.order_activity_id === activity.order_activity_id,
          );
          if (object == null) this.redList.push(activity);
        }
      });
    },
    async initChecklist() {
      /* EventBus.$on('activateTutorial', () => {
        this.showTooltip = false;
        if (!this.mobile) this.initTour();
        else this.initTutorialMobile();
      }); */
      this.SET_ACTIVATE_TUTORIAL(true);

      this.effectiveDate = this.$session.get('effectiveDate') !== undefined
        ? this.moment(this.$session.get('effectiveDate')).utc().format('DD-MM-YYYY')
        : '--';

      this.effectiveDateEnd = this.$session.get('effectiveDate') !== undefined
        ? this.moment(this.$session.get('effectiveDate')).utc().endOf('month').format('DD-MM-YYYY')
        : '--';

      await this.getAdditionalActivities();
      await this.getUnbudgetedActivities();
      this.updateAdditionalQuotationAmounts();
      await this.getPreinvoice();
      this.checkListActivities();

      if (this.showTotals) {
        this.total = this.Decimal(this.additionalTotal)
          .add(this.Decimal(this.taxesAmount))
          .add(this.Decimal(this.preInvoiceTotal))
          .toFixed(2)
          .toString();
      } else {
        this.total = this.Decimal(this.preInvoiceTotal)
          .toFixed(2)
          .toString();
      }

      if (this.addOtherCharges) {
        this.total = this.Decimal(this.total)
          .add(this.Decimal(this.otherCharges))
          .toFixed(2)
          .toString();
      }
    },
    async initialCharge() {
      try {
        if (this.activitiesEnable) {
          await this.getAdditionalActivities();
          await this.getUnbudgetedActivities();
        } else if (this.checklistEnable) {
          await this.initChecklist();
        }
        this.showView = true;
      } catch (error) {
        this.loaderError = true;
      }
    },
    initTutorialMobile() {
      this.showTutorialMobile = true;
      this.tutorialActive = true;
      this.showButtonCloseTutorial = true;
    },
    nextStep() {
      let next = null;
      this.stepTutorialMobile += 1;
      if (this.stepTutorialMobile === 3) next = 1;
      this.changeTutorialMobile(next);
    },
    previousStep() {
      let previous = null;
      this.stepTutorialMobile -= 1;
      if (this.stepTutorialMobile === 3) previous = 0;
      this.changeTutorialMobile(previous);
    },
    changeTutorialMobile(ban) {
      let image = null;

      switch (this.$session.get('brand')) {
        case 'volkswagen':
          image = vwgif;
          break;
        case 'audi':
          image = audigif;
          break;
        case 'seat':
          image = seatgif;
          break;
        default:
          break;
      }

      switch (this.stepTutorialMobile) {
        case 0:
          this.titleTutorialMobile = this.titleAdditionals;
          this.textTutorialMobile = this.subAdditionals;
          break;
        case 1:
          this.titleTutorialMobile = 'Checa los detalles de cada avería';
          this.textTutorialMobile = 'Da clic en el ícono y revisa los detalles';
          break;
        case 2:
          this.titleTutorialMobile = '¡Repara los detalles!';
          this.textTutorialMobile = `<div>Aquí podrás autorizar o rechazar las averías</div><div class='full-width text-center' style='height: 57px; width: 340px;'><img src='${image}' alt='toggle' /></div>`;
          break;
        case 3:
          if (this.checkRestriccions()) {
            this.titleTutorialMobile = 'Checa las restricciones del paquete';
            this.textTutorialMobile = 'Da clic en la etiqueta';
          } else {
            if (ban === 1) this.nextStep();
            if (ban === 0) this.previousStep();
          }
          break;
        case 4:
          window.scrollTo(0, this.$refs.activityTotal.$el.offsetHeight + 254);
          this.titleTutorialMobile = '¡Autoriza tu presupuesto aquí!';
          this.textTutorialMobile = 'Autoriza tus reparaciones y enseguida comenzaremos a trabajar, si tienes dudas, podrás contactar a tu asesor de servicio para aclararlas';
          break;
        case 5:
          this.showButtonCloseTutorial = false;
          this.showTotalMobile = false;
          this.isFinishTutorial = true;
          this.titleTutorialMobile = this.titleAdditionals;
          this.textTutorialMobile = this.subAdditionals;
          this.SET_ACTIVATE_TUTORIAL(false);
          break;
        default:
          break;
      }
    },
    resetTutorial(type) {
      if (this.driver != null) this.driver.reset();

      if (type === 'close') {
        this.isFinishTutorial = false;
        this.showTooltip = true;
        this.SET_ACTIVATE_TUTORIAL(false);
      }

      this.driver = null;
      this.tutorialActive = false;
      this.showButtonCloseTutorial = false;
      this.showTotalMobile = false;
      this.showTutorialMobile = false;
      this.stepTutorialMobile = 0;
      this.SET_ACTIVATE_TUTORIAL(false);
      this.updateTutorial();
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 500);
    },
    updateAdditionalQuotationAmounts() {
      this.responseComplete.forEach((activity) => {
        const clonedActivity = activity;
        let found = find(
          this.redList,
          (item) => activity.order_activity_id === item.order_activity_id,
        );
        if (found != null) clonedActivity.accepted = found.accepted;
        found = find(
          this.yellowList,
          (item) => activity.order_activity_id === item.order_activity_id,
        );
        if (found != null) clonedActivity.accepted = found.accepted;
      });

      const additionalQuotationAmounts = getAdditionalQuotationAmounts(this.responseComplete);
      this.taxesAmount = additionalQuotationAmounts.taxes;
      this.additionalTotal = additionalQuotationAmounts.subtotal;
      this.authorizedTotal = Number(additionalQuotationAmounts.total) + Number(this.otherCharges);
    },
    setActivitiesInSession() {
      const activities = {
        redList: clone(this.redList),
        yellowList: clone(this.yellowList),
      };
      this.$session.set('activities', activities);
    },
    updateTutorial() {
      if (this.$session.get('showTutorial') === 0 || this.$session.get('showTutorial') === null) {
        this.$session.set('showTutorial', true);
        this.SET_ACTIVATE_TUTORIAL(true);
        AdsApi.updateTutorial()
          .then((res) => {
            const responseData = res.data;

            if (!responseData.success) throw new Error(`[${responseData.errorCode}] ${responseData.errorDescription}`);
          });
      }
    },
    validateBudget() {
      this.rejectedActivities = [];
      this.rejectedActivities = this.rejectedActivities.concat(this.joinList(clone(this.redList), 'validate'));

      this.rejectedActivities = this.rejectedActivities.concat(this.joinList(clone(this.yellowList), 'validate'));

      if (this.rejectedActivities.length > 0) {
        this.isRejectedPoints = true;
      } else {
        this.isAuthGeneralBudget = true;
      }
    },
    updateActivitiesInSesion() {
      const activities = this.$session.get('activities');
      const redData = this.checkAcceptedInArrray(activities.redList, this.redList);
      const yellowData = this.checkAcceptedInArrray(activities.yellowList, this.yellowList);
      const data = {
        redList: redData,
        yellowList: yellowData,
      };
      this.$session.set('activities', data);
    },
    checkAcceptedInArrray(oldArray, newArray) {
      const data = [];
      newArray.forEach((item) => {
        const clonedItem = item;
        const activity = find(
          oldArray,
          (a) => a.order_activity_id === clonedItem.order_activity_id,
        );
        if (activity && Object.prototype.hasOwnProperty.call(activity, 'accepted') && !this.isAuthorized) { clonedItem.accepted = activity.accepted; }

        data.push({ ...item });
      });
      return data;
    },
    checkRestriccions() {
      let restrictions = false;
      if (this.redList && this.redList.length > 0) {
        if (
          this.redList[0].restrictions
          && this.redList[0].restrictions !== null
          && this.redList[0].restrictions.length > 0
        ) {
          restrictions = true;
        } else {
          restrictions = false;
        }
      } else {
        restrictions = false;
      }
      return restrictions;
    },
    checkListActivities() {
      if (
        this.redList
          .findIndex((activity) => activity.accepted
          && activity.activity_service_type === 1) >= 0
        || this.yellowList
          .findIndex((activity) => activity.accepted
          && activity.activity_service_type === 1) >= 0
      ) {
        this.addOtherCharges = true;
      } else {
        this.addOtherCharges = false;
      }
    },
    sortList(list) {
      return list.sort((a) => {
        if (a.evidence === 1) {
          return -1;
        }
        return 1;
      });
    },
  },
};
